import { useState, useEffect } from "react";
import "./css/header.css"
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';
const Header = (props) => {
    const location = useLocation();
    const [btnState, setBtnState] = useState(false)

    function handleClick() {
        setBtnState(btnState => !btnState)
    }
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    function contact() {
        setTimeout(() => {
            window.scrollTo(0, 500);
        }, 500)

    }

    let toggleClassCheck = btnState ? 'active' : null
    const mainLinks = [
        { to: "/", label: "หน้าหลัก" },
        { to: "/tour", label: "สถานที่ท่องเที่ยว" },
        { to: "/blog", label: "บทความ" },
        { to: "/services", label: "บริการของเรา" },
        { to: "/reviews", label: "รีวิว" },
        { to: "/faq", label: "คำถามที่พบบ่อย" },
        { to: "/about", label: "เกี่ยวกับเรา" },
    ]
    const contactLink = { to: "/about", label: "ติดต่อ", class: "cta" }
    const currentURL = location.pathname;

    return (
        <header>
            <div className="logo">
                <h1><Link to="/" className="text-black">
                    TAXI UBR Thailand
                </Link></h1>
            </div>
            <span className="nav-toggle" id="nav-toggle" onClick={handleClick}>
                <i className="bi bi-list"></i>
            </span>
            <nav>
                <div className={`nav-wrapper ${toggleClassCheck}`} id="nav-menu">
                    {/* Main navigation links - centered */}
                    <ul className="nav-main-menu">
                        {mainLinks.map((link) => (
                            <li key={link.label}>
                                <Link className={currentURL === link.to ? 'link-active' : null} to={link.to}>
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                    {/* Contact button - right aligned */}
                    <div className={contactLink.class}>
                        <Link to={contactLink.to} onClick={contact}>
                            <button>{contactLink.label}</button>
                        </Link>
                    </div>
                </div>
            </nav>
        </header>
    )
}

export default Header